import { render, staticRenderFns } from "./bottom-banner.vue?vue&type=template&id=eb6cb120&"
import script from "./bottom-banner.vue?vue&type=script&lang=js&"
export * from "./bottom-banner.vue?vue&type=script&lang=js&"
import style0 from "./bottom-banner.vue?vue&type=style&index=0&id=eb6cb120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports